/**
 * Lightweight bus for call-related ephemeral events from the sync store.
 *
 * Call state is intentionally outside the durable event log, so it does not
 * belong in IndexedDB. Components subscribe here instead.
 */

import type { CallInvitedEvent, CallUpdatedEvent } from '@/api/types'

export type CallEphemeralEvent = CallInvitedEvent | CallUpdatedEvent

type Listener = (event: CallEphemeralEvent) => void

const listeners = new Set<Listener>()

export function subscribeCallEvents(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function emitCallEvent(event: CallEphemeralEvent): void {
  for (const listener of listeners) listener(event)
}
